import { render, staticRenderFns } from "./UploaderGood.vue?vue&type=template&id=c8c34c92&scoped=true&"
import script from "./UploaderGood.vue?vue&type=script&lang=ts&"
export * from "./UploaderGood.vue?vue&type=script&lang=ts&"
import style0 from "./UploaderGood.vue?vue&type=style&index=0&id=c8c34c92&lang=less&scoped=true&"
import style1 from "./UploaderGood.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c34c92",
  null
  
)

export default component.exports